<div style="position: fixed; top:0; z-index: 11; left:0; height:100%; width:100%; background: #222c;">
</div>


<div style="z-index: 12; width: 90%; height: 90vh;" class="centered scrollable-vertical">
  <ion-icon color='danger' name="close-circle" class='font2 floatRight floatingCloseAttachment cursorpoint'
    (click)='closePopup.emit()'></ion-icon>
  <div class="padding20 font1_2">
    <!-- <ion-row>
      <ion-col size="12" sizeMd="4">
        <app-a-input [label]="'वर्तमान Address'" [(variable)]="emp.user.current_address"></app-a-input>
      </ion-col>

      <ion-col size="12" sizeMd="4">
        <app-a-input [label]="'स्थायी Address'" [(variable)]="emp.user.permanentAddress"></app-a-input>
      </ion-col>

      <ion-col size="12" sizeMd="4">
        <app-a-input [label]="'शहर'" [(variable)]="emp.user.city"></app-a-input>
      </ion-col>

      <ion-col size="12" sizeMd="4">
        <app-a-input [label]="'Place of Origin'" [(variable)]="emp.user.origin_city"></app-a-input>
      </ion-col>
    </ion-row> -->
    <ion-button expand="block">
      Done
    </ion-button>
  </div>
</div>